import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e07e422"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-wrap" }
const _hoisted_2 = { class: "news" }
const _hoisted_3 = { class: "news-content-block margin-l-r" }
const _hoisted_4 = { class: "news-content-block-image" }
const _hoisted_5 = ["innerHTML"]

import {WrapTitle} from "../../entities";
import {NewsContent} from "../../widgets";
import {news_1_img, useDataStore, useLocalizationStore} from "../../shared";
import {onMounted} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'news-one-page',
  setup(__props) {

const {translate} = useLocalizationStore();
const {scrollTop} = useDataStore();

onMounted(() => {
  scrollTop();
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(WrapTitle), {
          text: _unref(translate)('news_1_title'),
          class: "news-content-block-wrap-title",
          size: "regular",
          weight: "700"
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_img, {
            class: "w-100",
            src: require('@/shared/assets/images/new/news_1_img.svg'),
            "aspect-ratio": undefined
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", {
          class: "news-content-block-sub-title",
          style: {"margin-top":"30px","margin-bottom":"30px","font-size":"16px"},
          innerHTML: _unref(translate)('news_1_body')
        }, null, 8, _hoisted_5)
      ]),
      _createVNode(_unref(NewsContent), { showSelectedNews: true })
    ])
  ]))
}
}

})